import React from 'react'

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  }

  return (
    <div className={`flex items-center justify-center min-h-screen ${className}`}>
      <div className="flex flex-col items-center gap-4">
        <div className={`spinner ${sizeClasses[size]}`}></div>
        <p className="text-gray-400 text-sm">Loading The Launch Pad...</p>
      </div>
    </div>
  )
}

export default LoadingSpinner
